const isEmpty = (value: unknown): boolean => {
  if (value === null || value === undefined) {
    return true;
  }
  if (typeof value === 'string') {
    return value.trim().length === 0;
  }
  if (Array.isArray(value)) {
    return value.length === 0;
  }
  if (typeof value === 'object' && value.constructor === Object) {
    return Object.keys(value).length === 0;
  }
  return false;
};

export const makeFiltersOptional = <T extends object>(filters: T): Partial<T> =>
  Object.fromEntries(
    Object.entries(filters).map(([key, value]) => [key, isEmpty(value) ? undefined : value]),
  ) as Partial<T>;
